import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Dna
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgMTYgMS41IDEuNSIgLz4KICA8cGF0aCBkPSJtMTQgOC0xLjUtMS41IiAvPgogIDxwYXRoIGQ9Ik0xNSAyYy0xLjc5OCAxLjk5OC0yLjUxOCAzLjk5NS0yLjgwNyA1Ljk5MyIgLz4KICA8cGF0aCBkPSJtMTYuNSAxMC41IDEgMSIgLz4KICA8cGF0aCBkPSJtMTcgNi0yLjg5MS0yLjg5MSIgLz4KICA8cGF0aCBkPSJNMiAxNWM2LjY2Ny02IDEzLjMzMyAwIDIwLTYiIC8+CiAgPHBhdGggZD0ibTIwIDkgLjg5MS44OTEiIC8+CiAgPHBhdGggZD0iTTMuMTA5IDE0LjEwOSA0IDE1IiAvPgogIDxwYXRoIGQ9Im02LjUgMTIuNSAxIDEiIC8+CiAgPHBhdGggZD0ibTcgMTggMi44OTEgMi44OTEiIC8+CiAgPHBhdGggZD0iTTkgMjJjMS43OTgtMS45OTggMi41MTgtMy45OTUgMi44MDctNS45OTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/dna
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const Dna = createLucideIcon('dna', [
  ['path', { d: 'm10 16 1.5 1.5', key: '11lckj' }],
  ['path', { d: 'm14 8-1.5-1.5', key: '1ohn8i' }],
  ['path', { d: 'M15 2c-1.798 1.998-2.518 3.995-2.807 5.993', key: '80uv8i' }],
  ['path', { d: 'm16.5 10.5 1 1', key: '696xn5' }],
  ['path', { d: 'm17 6-2.891-2.891', key: 'xu6p2f' }],
  ['path', { d: 'M2 15c6.667-6 13.333 0 20-6', key: '1pyr53' }],
  ['path', { d: 'm20 9 .891.891', key: '3xwk7g' }],
  ['path', { d: 'M3.109 14.109 4 15', key: 'q76aoh' }],
  ['path', { d: 'm6.5 12.5 1 1', key: 'cs35ky' }],
  ['path', { d: 'm7 18 2.891 2.891', key: '1sisit' }],
  ['path', { d: 'M9 22c1.798-1.998 2.518-3.995 2.807-5.993', key: 'q3hbxp' }],
]);

export default Dna;
